export const MAX_PREVIEWABLE_IMAGE_SIZE = 5 * 1024 * 1024 // 5mb

// File types that can be embedded in emails using CID tags
export const embeddableFileType = fileType => {
  if (fileType.match(/^audio/)) return true
  if (fileType.match(/^image/)) return true

  return false
}
